// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2xPo7","buttons":"Footer_buttons__meaCs"};